import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import ui from '@alpinejs/ui';
import Swiper, { Pagination } from 'swiper';

Alpine.plugin(ui);
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

export function initAlpinejs() {
  window.Alpine = Alpine;
  Alpine.start();
}

Alpine.data('courseHighlights', (courses) => ({
  init() {
    this.initSwiper();
  },
  swiper: false,
  courses,
  currentMonth: new Date().toLocaleString('DE-de', { month: 'long' }),
  initSwiper() {
    this.swiper = new Swiper(this.$refs.container, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  },
  updateSwiper() {
    this.swiper.update();
  },
  get filteredCourses() {
    return this.courses.filter((course) => {
      return course.month == this.currentMonth;
    });
  },
  get months() {
    return this.courses
      .map((course) => course.month)
      .filter((value, index, self) => self.indexOf(value) === index);
  },
}));

Alpine.data('bundleHighlights', (bundles) => ({
  init() {
    this.initSwiper();
  },
  swiper: false,
  bundles,
  activeCategory: bundles[0].category,
  initSwiper() {
    this.swiper = new Swiper(this.$refs.container, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  },
  updateSwiper() {
    this.swiper.update();
  },
  get filteredBundles() {
    return this.bundles.filter((bundle) => {
      return bundle.category == this.activeCategory;
    });
  },
  get categories() {
    return this.bundles
      .map((bundle) => bundle.category)
      .filter((value, index, self) => self.indexOf(value) === index);
  },
}));

Alpine.data('companyFactsCounter', (target, time = 200) => ({
  start: 0,
  current: '0',
  tmp: 0,
  target: target,
  time: time,
  startCounter() {
    const increment = (this.target - this.start) / this.time;
    const handle = setInterval(() => {
      if (this.tmp < this.target) {
        this.tmp += increment;
        this.current = Math.round(this.tmp).toLocaleString();
      } else {
        clearInterval(handle);
        this.current = this.target.toLocaleString();
      }
    }, 1);
  },
}));

Alpine.data('formatsContainer', (initialActive) => ({
  active: initialActive,
}));

Alpine.data('formatsNavigation', (id) => ({
  id,
  get expanded() {
    return this.active === this.id;
  },
  set expanded(value) {
    console.log('set');
    this.active = value ? this.id : null;
  },
}));
